import React, { useEffect } from "react";
import { styled } from "@mui/system";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const IframeWrapper = styled("div")({
  position: "fixed", // Use fixed or absolute as needed
  top: 50,
  left: 0,
  right: 0,
  bottom: 100,
  width: "100vw",
  height: "80vh",
  zIndex: 9998,
});

const StyledIframe = styled("iframe")({
  width: "100%",
  height: "100%",
  border: "none",
});

const CloseButton = styled(IconButton)({
  position: "absolute",
  top: 0,
  right: 0,
  backgroundColor: "#575757", // or any color that matches your design
  color: "white",
  borderRadius: "0", // Optional: if you want a square button
  "&:hover": {
    backgroundColor: "#f0f0f0", // Slightly  darker on hover
  },
  zIndex: 9999, // Ensure the  button is above the iframe
});

const FullPageIframe = ({ src, onClose }) => {
  useEffect(() => {
    if (typeof window.sendFbEvent === "function") {
      window.sendFbEvent("track", "InitiateCheckout");
    }
  }, []);
  return (
    <IframeWrapper>
      <CloseButton onClick={onClose}>
        <CloseIcon />
        {/* Close */}
      </CloseButton>
      <StyledIframe src={src} allowFullScreen />
    </IframeWrapper>
  );
};

export default FullPageIframe;
